// extracted by mini-css-extract-plugin
export default {"fav":"AnnotateButton-module__fav","active":"AnnotateButton-module__active","border":"AnnotateButton-module__border","icon":"AnnotateButton-module__icon"};